import React from 'react';
// import TableWithSummary from '../../../../components/table/TableWithSummary';
// import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
// import { useAuth } from '../../..../hooks/common/useAuth';
// import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../constants/service/common/userPermissions';
import { useQuery } from '@tanstack/react-query';
import { settlementQuery } from '../../queries';
import { convertBrandsToSettlementItemByBrands } from '../../utils';
import { OnChangeFn, PaginationState } from '@tanstack/react-table';
import columns from './columns';
import { TanstackControlledTable } from '../../../../components/TanstackTable';
import { StyledTableWrapper } from './styles';
import { SettlementItemsQueryParams } from '../../types/apis';
import { isAxiosError } from 'axios';
import SettlementListByBrandToolbar from '../SettlementListByBrandToolbar';

type Props = {
  request: SettlementItemsQueryParams;
  paginationState: [PaginationState, OnChangeFn<PaginationState>];
};

const SettlementListByBrand = ({ request, paginationState }: Props): JSX.Element => {
  // const { can } = useAuth();

  const { data, isError, error } = useQuery({
    ...settlementQuery.listByBrand(request),
    select: ({ totalCount, brands }) => {
      return { rowCount: totalCount, brands: convertBrandsToSettlementItemByBrands(brands) };
    },
    keepPreviousData: true,
  });

  if (isError) {
    if (isAxiosError(error)) {
      throw new Error(`SettlementListByBrand: ${error.message}`);
    }

    throw new Error(`SettlementListByBrand: ${error}`);
  }

  return (
    <StyledTableWrapper>
      <SettlementListByBrandToolbar totalCount={data?.rowCount ?? 0} />
      <TanstackControlledTable
        emptyText="요청하신 검색 필터로 검색된 정산 리스트가 없습니다."
        data={data?.brands ?? []}
        columns={columns}
        paginationState={paginationState}
        columnPinning={['id', 'mainImageUrl', 'brandId', 'brandName']}
        rowCount={data?.rowCount ? data?.rowCount : 0}
      />
    </StyledTableWrapper>
  );

  {
    /* <TableWithSummary
        totalCnt={mockSettlementItems.length}
        head={
          <Fragment>
            <Button
              isRadius
              color="primary"
              text="정산 아이템 엑셀 다운"
              // onClick={() => getBalanceItemListExcelDownload()}
            />
            {can(PERMISSION_ACTIONS.UPDATE, PERMISSION_SUBJECTS.BALANCE) ? (
              <Button
                isRadius
                color="light"
                text="정산 일괄 처리"
                // onClick={() => bulkEditBalance()}
              />
            ) : null}
          </Fragment>
        }
        initialOption={{
          pagination: SETTLEMENT_SORT_PAGINATION_MODEL,
        }}
        emptyText={BALANCE_LIST_TABLE_EMPTY_TEXT}
        showPagination
      /> */
  }
};

export default SettlementListByBrand;
